








import { Component, Vue } from 'vue-property-decorator';
import OccupationSelectionList from '@/components/Occupation/OccupationSelectionList.vue';
import OccupationSelectionForm from '@/components/Occupation/OccupationSelectionForm.vue';

@Component({
  components: {
    OccupationSelectionList,
    OccupationSelectionForm,
  },
})
export default class Occupations extends Vue {}
